import * as React from 'react';

export const useKeyDown = (key: string, handler: (e?: React.KeyboardEvent) => void) => {
  React.useEffect(() => {
    const handleKeypress = (event: KeyboardEvent) => {
      if (event.key === key) {
        handler();
      }
    };
    window.addEventListener('keydown', handleKeypress);
    return () => {
      window.removeEventListener('keydown', handleKeypress);
    };
  }, [handler, key]);
};
